import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans du module Médias chargés à la demande.
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const pages = () => import('./MediasPages.js');
const MesPhotosPage = page(pages, 'MesPhotosPage');
const FiligranePage = page(pages, 'FiligranePage');
const TriPage = page(pages, 'TriPage');
const SourcesPage = page(pages, 'SourcesPage');
const EtatPage = page(pages, 'EtatPage');

/** Routes du module Médias (module.json `navigation`, spec 011). */
export const mediasWeb: ModuleWeb = {
  module: 'medias',
  routes: [
    { path: '/medias/mes-photos', element: <MesPhotosPage /> },
    { path: '/medias/filigrane', element: <FiligranePage /> },
    { path: '/medias/tri', element: <TriPage /> },
    { path: '/medias/sources', element: <SourcesPage /> },
    { path: '/medias/etat', element: <EtatPage /> },
  ],
};
